module.exports = __webpack_public_path__ + "img/shiba-body-level4.c4177bc4.png";